import { Injectable, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationAlphanamePopupComponent } from '../../components/confirmation-alphaname-popup/confirmation-alphaname-popup.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';

// we need to provide this service globally
// because it's used by other shared entities
@Injectable({providedIn: 'root'})
export class NotificationService {
  toasts: any[] = [];

  constructor(private modalServce: NgbModal) {}

  showConfirmationWithAlphaname(message: string, alphaname: string) {
    const ref = this.modalServce.open(ConfirmationAlphanamePopupComponent, { keyboard: false })
    ref.componentInstance.message = message;
    ref.componentInstance.alphaname = alphaname;
    ref.componentInstance.params = { alphaname };
    return ref.result;
  }

  showFlagConfirmationWithAlphaname(message: string, alphaname: string, flag: string) {
    const ref = this.modalServce.open(ConfirmationAlphanamePopupComponent, { keyboard: false });
    ref.componentInstance.message = message;
    ref.componentInstance.alphaname = alphaname;
    ref.componentInstance.params = { alphaname, flag };
    return ref.result;
  }

  showConfirmation(message: string) {
    const ref = this.modalServce.open(ConfirmationPopupComponent)
    ref.componentInstance.message = message;
    return ref.result;
  }

  showConfirmationWithParams(message: string, params: Record<string, string>) {
    const ref = this.modalServce.open(ConfirmationPopupComponent)
    ref.componentInstance.message = message;
    ref.componentInstance.params = params;
    return ref.result;
  }

  show(message: string, options: any = {}) {
    this.toasts.push({ message, ...options });
  }

  error(message: string, overrideOptions?) {
    const options = {
      classname: 'bg-danger text-light',
      iconclass: 'icon-small-alert text-light',
      ...overrideOptions
    }
    this.show(message,options);
  }

  success(message: string, overrideOptions?) {
    const options = {
      classname: 'bg-success text-light',
      iconclass: 'icon-small-check-circle text-light',
      ...overrideOptions
    };
    this.show(message,options);
  }

  remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  removeAllToast() {
    this.toasts = [];
  }

}
